<script>
import moment from 'moment';
export default {
  name: 'SelectionHistoryStats',
  props: {
    competitorId: {
      type: String,
      required: true,
    },
    record: {
      type: Object,
      required: true,
    },
  },
  computed: {
    meetingInfoString() {
      const { getTrackName, getEventDate } = this;
      return `${getTrackName} ${getEventDate}`;
    },
    displayString() {
      const { record, getPrizeWinnings, getTotalPrizeMoney, getEventCondition, getSelectionBarrier } = this;
      return `${record.distance}m  R${
        record.event_number
      } ${getEventCondition}  $${getPrizeWinnings} (of $${getTotalPrizeMoney}) ${getSelectionBarrier}`;
    },
    getTrackName() {
      const { record } = this;
      return record.venue ? record.venue.track_name : '';
    },
    getEventDate() {
      const { record } = this;
      const date = moment
        .utc(record.start_time)
        .local()
        .format('DD-MMM-YY');
      return date;
    },
    getEventCondition() {
      const { record } = this;
      const entryClass = record.entry_conditions.filter(event => {
        return event.type == 'raceClassRestriction';
      });
      return entryClass.length > 0 ? entryClass[0].description : '';
    },
    getPlaceWinners() {
      const { record } = this;
      return record.place_winners || 3;
    },
    getPrizeWinnings() {
      const { record, getSelectionPostition } = this;
      const position = getSelectionPostition;
      const prizeWinningsArray = record.prize_money.filter(item => {
        return item.position === position;
      });
      return prizeWinningsArray.length > 0 ? prizeWinningsArray[0].value : 0;
    },
    getTotalPrizeMoney() {
      const { record } = this;
      const prizeMoneyArray = record.prize_money.map(prize => prize.value);
      return prizeMoneyArray.length > 0 ? prizeMoneyArray.reduce((a, b) => parseInt(a) + parseInt(b)) : '0';
    },
    getSelectionPostition() {
      const { record } = this;
      if (record.results.length > 0) {
        const filteredResult = record.results.filter(item => {
          if (item.competitor_id) return item.competitor_id === this.competitorId;
        });
        return filteredResult.length > 0 ? filteredResult[0].finish_position : '';
      }
    },
    getSelectionBarrier() {
      const { record } = this;
      if (record.results.length > 0) {
        const filteredResult = record.results.filter(item => {
          if (item.competitor_id) return item.competitor_id === this.competitorId;
        });
        return filteredResult.length > 0 ? filteredResult[0].barrier : '';
      }
    },
    resultsList() {
      const { record } = this;
      if (record.results.length > 0) {
        const { getPlaceWinners } = this;
        const noOfPlaceWinners = getPlaceWinners;
        const orderedResults = record.results.sort((a, b) => a.finish_position - b.finish_position);
        const placeWinners = orderedResults.slice(0, noOfPlaceWinners);
        const selectionPlaced = placeWinners.filter(item => {
          return item.competitor_id === this.competitorId;
        });
        // return placed winners along with selection
        if (selectionPlaced.length > 0) {
          return placeWinners;
        } else {
          const selectionResult = record.results.filter(item => {
            return item.competitor_id === this.competitorId;
          });
          return selectionResult.length > 0 ? placeWinners.concat(selectionResult[0]) : '';
        }
      }
    },
    selectionPlaceClass() {
      const { getSelectionPostition, getPlaceWinners } = this;
      const position = getSelectionPostition;
      const placeWinners = getPlaceWinners;
      if (position == 1) return 'win';
      if (position > 1 && position <= placeWinners) return 'place';
      return '';
    },
  },
  methods: {
    resultString(result) {
      const { competitor_name, jockey_name, margin_decimal } = result;
      return margin_decimal
        ? `${competitor_name} (${jockey_name}) ${margin_decimal}L`
        : `${competitor_name} (${jockey_name})`;
    },
  },
};
</script>

<template>
  <div class="selection-history-stats">
    <div class="selection-history-stats__container">
      <!-- event record info -->
      <div class="selection-history-stats__record">
        <div class="selection-history-stats__timeline">
          <div :class="`selection-history-stats__position ${selectionPlaceClass}` ">
            <span class="selection-history-stats__position-text">{{ getSelectionPostition }}</span>
            <span class="selection-history-stats__position-sub-text">of {{ record.starters }}</span>
          </div>
        </div>
        <span class="selection-history-stats__box-arrow"></span>
        <span class="selection-history-stats__box-arrow-shadow"></span>
        <div class="selection-history-stats__event-results">
          <div class="selection-history-stats__event-info">
            <b>{{ meetingInfoString }}</b>
            <div class="selection-history-stats__event-condition">GOOD</div>
            {{ displayString }}
          </div>
          <div class="selection-history-stats__results">
            <template v-for="(result, index) in resultsList">
              <div
                :key="`result-${index}`"
                :class="{'is-selection': result.competitor_id === competitorId}"
                class="selection-history-stats__result"
              >{{ result.finish_position | numberOrdinal }} {{ resultString(result) }}</div>
            </template>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
